import { motion } from 'framer-motion';

import './technology.css';

import python from '../../assets/tech/python.svg';
import aws from '../../assets/tech/aws.svg';
import swift from '../../assets/tech/swift.svg';
import android from '../../assets/tech/android.svg';
import golang from '../../assets/tech/golang.svg';
import kotlin from '../../assets/tech/kotlin.svg';
import googleCloud from '../../assets/tech/google-cloud.svg';
import flutter from '../../assets/tech/flutter.svg';
import ios from '../../assets/tech/ios.svg';

const Technology = ({ pageRef }) => {

  const techs = [{
    title: "AWS",
    logo: aws
  }, {
    title: "Google Cloud",
    logo: googleCloud
  }, {
    title: "iOS",
    logo: ios
  }, {
    title: "Android",
    logo: android
  }, {
    title: "Flutter",
    logo: flutter
  }, {
    title: "Python",
    logo: python
  }, {
    title: "Go",
    logo: golang
  }, {
    title: "Swift",
    logo: swift
  }, {
    title: "Kotlin",
    logo: kotlin
  }]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  const techItemVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 10
      }
    }
  };

  return (
    <section ref={pageRef} className="technology-section" id="technology">
      <motion.div
        className="technology-container"
        variants={containerVariants}
        initial="visible"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
      >
        <motion.div className="technology-content" variants={itemVariants}>
          <h2 className="technology-title">Technology</h2>
          <p className="technology-description">
            Solution architecture, project management, configuration management, mobile and cloud
            technologies, and cutting-edge AI solutions - this is just a short glance at a list of practices
            that we offer and use. We specialize in integrating artificial intelligence and machine learning
            into your business processes, from intelligent automation to predictive analytics. We think about
            business, taking care of the transparency and predictability of our work and looking for the best
            value for your money.
          </p>
        </motion.div>

        <motion.div className="tech-grid" variants={containerVariants}>
          {techs.map((item, index) => (
            <motion.div
              key={index}
              className="tech-card"
              variants={techItemVariants}
              whileHover={{
                scale: 1.1,
                rotate: 5,
                transition: { duration: 0.2 }
              }}
            >
              <img src={item.logo} alt={item.title} />
              <span className="tech-name">{item.title}</span>
            </motion.div>
          ))}
        </motion.div>

        <motion.div className="features-text-grid" variants={containerVariants}>
          <motion.h3 className="feature-gradient-text" variants={itemVariants} initial="visible">
            Fast Development
          </motion.h3>
          <motion.h3 className="feature-gradient-text" variants={itemVariants} initial="visible">
            Business Focus
          </motion.h3>
          <motion.h3 className="feature-gradient-text" variants={itemVariants} initial="visible">
            Scalable Solutions
          </motion.h3>
        </motion.div>
      </motion.div>
    </section>
  )
}

export default Technology;
